import styled from '@emotion/styled';
import { getBackgroundTheme, getTextColor } from '../../../style/index';
import { CloseBtn } from '../../../components/common/CommonStyle';

export const defaultModalStyle = () => {
  return {
    overlay: {
      zIndex: 8000,
      overflowY: 'auto',
      backgroundColor: 'rgba(0,0,0,0.65)',
    },
    content: {
      margin: '0 auto',
      outline: 'none',
      boxSizing: 'border-box',
      transform: 'scale(1)',
      borderRadius: '10px',
      bottom: 'initial',
      ':focus': {
        outline: 'none',
      },
      overflow: 'auto',
      backgroundColor: getBackgroundTheme().block2,
    },
  };
};

export const Title = styled('h1')<{ customStyle?: React.CSSProperties }>(({ customStyle }) => ({
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '-0.3px',
  fontFamily: 'DM Serif Display',
  ...customStyle,
  ...getTextColor().TITLE,
}));

export const Description = styled('p')(() => ({
  margin: '10px 0px 10px 0px',
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '20px',
  letterSpacing: '-0.3px',
  ...getTextColor().DARK_2,
}));

export const ClosedButton = styled(CloseBtn)({
  width: 24,
  height: 24,
  top: 15,
  right: 10,
});

export const List = styled('ul')(() => ({
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '20px',
  letterSpacing: '-0.3px',
  paddingInlineStart: '30px',
  margin: '15px 0px 30px 0px',
  '& > li': {
    marginBottom: '10px',
  },
  ...getTextColor().DARK_2,
}));

export const ImageWrapper = styled('div')({
  textAlign: 'center',
  margin: '15px 0px 5px 0px',
});

export const SelfieImageWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  marginTop: 15,
});

export const ElipseDiv = styled('div')({
  width: '188px',
  height: '280px',
  borderRadius: '50% / 50%',
  overflow: 'hidden',
  objectFit: 'cover',
  border: '2px solid #D9D9D9',
});

export const HeadingWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const iconStyle = {
  width: 40,
  height: 40,
  margin: '0px 8px 0px 0px',
};

export const ButttonWrapper = styled('div')({
  textAlign: 'center',
});

export const buttonCustomStyle = {
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '16px',
  borderRadius: '4px !important',
};
